import { useState, useEffect } from "react";
interface Translations {
  productTypes?: { standard: string; firstDiscount: string; secondDiscount: string; tomorrowArrival: string; koreaOrderShipping: string; koreaOrderDeliveryEstimate: string; };
  home?: { loadingProducts: string; productsLoadFailed: string; };
  settings?: {
    language: string;
    languageSelection: string;
    openSourceLicense: string;
    currentVersion: string;
    version: string;
    pushNotificationOff: string;
    pushNotificationOn: string;
    pushNotification: string;
    title: string;
  };
  curation?: {
    preferred?: {
      title: string;
      content: string;
      label: string;
    };
    discovered?: {
      title: string;
      content: string;
      label: string;
    };
    remaining: string;
    availableCoupon: string;
  };
  languageOptions?: {
    ko: string;
    vi: string;
    en: string;
  };
  languageChangeSuccess?: string;
  button?: {
    save: string;
    edit: string;
    delete: string;
    add: string;
    address: string;
    payment: string;
    cancel: string;
    no: string;
    yes: string;
    buy: string;
    select: string;
  };
  productInfo?: {
    title: string;
    sellerInformation: string;
    refundPolicy: string;
    companyNameRep: string;
    brand: string;
    businessNumber: string;
    orderSalesNumber: string;
    contact: string;
    email: string;
    address: string;
    productIntro: string;
    color: string;
    size: string;
    manufacturer: string;
    washingInstructions: string;
    productionDate: string;
    warrantyStandard: string;
    serviceContact: string;
  };
  brand?: {
    collection: string;
    title: string;
    discover: string;
    brand: string;
  };
  order?: {
    orderNumber: string;
    shipingFee: string;
    information: string;
    recipient: string;
    address: string;
    intructions: string;
    detailPayment: string;
    productPrice: string;
    discount: string;
    coupon: string;
    applied: string;
    totalAmount: string;
    fullPayment: string;
    installmentsMonth: string;
    paymentDate: string;
    cancelPayment: string;
    descriptionCancel: string;
    confirmCancel: string;
    cancelFailed: string;
    cancelUnavailable: string;
    title: string;
    trackDelivery: string;
    returnInquiry: string;
    checkDetail: string;
    submit: string;
    returnReason: string;
    character: string;
    detailInquiry: string;
    reviewInquiry: string;
    completeInquiry: string;
    exchangeInquiry: string;
    returnBankAccount: string;
    returnBankAccountNumber: string;
  };
  productDetail?: {
    noti: {
      addCart: string;
      goCart: string;
    };
    left: string;
    soldOut: string;
    soldOutDescription: string;
    originalPrice: string;
    discount: string;
    defaultDeceleration: string;
    rememberForYou: string;
    deliveryInformation: string;
    immediateDeparture: string;
    order: string;
    depart: string;
    discoShipping: string;
    sellerShipping: string;
    shippingFee: string;
    collaspe: string;
    view: string;
    title: string;
    options: string;
    oneOption: string;
    totalAmount: string;
    productOptions: string;
    description: string;
    deliveryPricePaidType: string;
    deliveryPriceFreeType: string;
  };
  invite?: {
    title: string;
    myCode: string;
    soulmates: string;
    refer: string;
    take: string;
    copy: string;
  };
  promotion?: {
    emptyProductList: string;
    promotion: string;
  };
  profile?: {
    editTitle: string;
    title: string;
    nickname: string;
    birthday: string;
    addressTitle: string;
    recipient: string;
    contact: string;
    account: string;
    linked: string;
    deleteAccount: string;
    shiping: string;
    coupon: string;
    productInquiry: string;
    noInquiry: string;
    customerSupport: string;
    termsOfService: string;
    privacyPolicy: string;
    logout: string;
    removeAccount: string;
    accountbeenDeleted: string;
    goodbye: string;
    ok: string;
    basicNotiCheck: string;
    basicNotiProfile: string;
    basicNotiCheckSuccess: string;
    editProfile: string;
    basicNickName: string;
    basicInputName: string;
    basicInputCheck: string;
    basicBirthday: string;
    sir: string;
    noAddress: string;
    duplicate: string;
    referalCode: string;
    agree: string;
    service: string;
    privacy: string;
    and: string;
    registerComplete: string;
    okay: string;
    inputBirthday: string;
  };
  onboard?: {
    address: string;
    join: string;
    check: string;
    gride: string;
    ceo: string;
    name: string;
    detailAdress: string;
    phone: string;
    email: string;
    business: string;
    onlineSale: string;
    conditions: string;
    privacy: string;
    refund: string;
  };
  delivery?: {
    loading: string;
    loadFailed: string;
    retry: string;
    preparing: string;
    all: string;
    inStransit: string;
    delivered: string;
    cancel: string;
    return: string;
    noResult: string;
    method: string;
    atHome: string;
    productSoldOut: string;
    productDiscontinued: string;
  };
  payments?: {
    cancelled: string;
    completed: string;
    pending: string;
    failed: string;
    cod: string;
  };
  exchanges?: {
    requested: string;
    approved: string;
    rejected: string;
  };
  returns?: {
    requested: string;
    approved: string;
    rejected: string;
  };
  question?: {
    deleteAccount: string;
    proceeding: string;
    first: string;
    second: string;
    third: string;
    fourth: string;
    required: string;
  };
  address?: {
    titleDetail: string;
    title: string;
    addNew: string;
    edit: string;
    nameUser: string;
    detail: string;
    province: string;
    district: string;
    ward: string;
    street: string;
    streetNone: string;
    phone: string;
    default: string;
    updated: string;
    created: string;
    deleted: string;
    different: string;
    register: string;
    titleAddressPopupDelete: string;
    addressNotRecovered: string;
    defaultAddress: string;
    otherAddress: string;
  };
  shop?: {
    title: string;
    quanity: string;
  };
  product?: {
    title: string;
    product: string;
    price: string;
    coupon: string;
    total: string;
    payment: string;
    collect: string;
    move: string;
    myCoupons: string;
    max: string;
    min: string;
    recomend: string;
    loadingPayment: string;
    orderFailed: string;
  };
  cart?: {
    orderLimitExceeded: string;
    title: string;
    none: string;
    continue: string;
    deleteAll: string;
    couponUnapply: string;
    quanity: string;
    discountAmount: string;
    payment: string;
    fee: string;
    discountFee: string;
    applyCoupon: string;
    soldout: string;
    saleEnd: string;
    popup: {
      removeSuccess: string;
      item: string;
      removeAll: string;
    };
  };
  notification?: {
    title: string;
    noNotification: string;
    noNewNotification: string;
    newNotification: string;
    readed: string;
    inquiryReplyReceived: string;
    limitedItemOpened: string;
    startDelivery: string;
    completedDelivery: string;
    copy: string;
  };
  limited?: {
    title: string;
    catchHint: string;
    nextOpen: string;
    preparingNext: string;
    start: string;
    play: string;
    test: string;
    cancel: string;
    style: string;
    examTitle: string;
    sex: string;
    female: string;
    male: string;
    next: string;
    timeSeceret: string;
    myStyle: string;
    bonus: string;
    checkOut: string;
    congratulations: string;
    happy_treasure_hunting_today: string;
    see_you_again_tomorrow: string;
  };
  friend?: {
    title: string;
    invite: string;
    double: string;
    reward: string;
  };
  examSection?: {
    style: string;
  };
  coupon?: {
    title: string;
    noneCoupons: string;
    apply: string;
    pcs: string;
    remove: string;
    collect: string;
    move: string;
    myCoupons: string;
    discoverShip: string;
    shippingCoupon: string;
    startStyle: string;
    skip: string;
    haveCoupons: string;
    applied: string;
    max: string;
    notApplicable: string;
    notFound: string;
    hours: string;
    days: string;
    useWithin: string;
    condition: string;
    behind: string;
  };
  fashion?: {
    title: string;
    question: string;
  };
  intro?: {
    title: string;
    left: string;
    right: string;
    start: string;
    upLove: string;
    up: string;
  };
  licenses?: {
    title: string;
  };
  navigation?: {
    home?: string;
    limitedOffer: string;
    cart: string;
    mypage: string;
  };
  fashionResult?: {
    text1?: string;
    resultTest?: string;
    retake?: string;
    share?: string;
    redirect?: string;
    intall?: string;
    curation?: string;
    notifi?: string;
    retrying?: string;
    retry?: string;
    compeleted?: string;
    testCompleted?: string;
    freeShipping?: string;
    check?: string;
    coupon?: string;
    recommend?: string;
    yourStyle?: string;
    waitting?: string;
    goHome?: string;
  };
  auth?: {
    phoneLogin?: string;
    phoneLoginHeading?: string;
    phoneLoginDesc?: string;
    phoneNumber?: string;
    phoneRequired?: string;
    phoneInvalid?: string;
    sendOTP?: string;
    sending?: string;
    otpSent?: string;
    otpSendFailed?: string;
    enterOTP?: string;
    otpSentTo?: string;
    verificationCode?: string;
    otpRequired?: string;
    verify?: string;
    verifying?: string;
    resendOTP?: string;
    otpResent?: string;
    otpVerifyFailed?: string;
    loginSuccess?: string;
    continue?: string;
    otpExpired?: string;
    notReceivedOtp?: string;
    otpFaildToMuch?: string;
    otpInstruction1?: string;
    otpInstruction2?: string;
    pick?: string;
  };
  search?: {
    title: string;
    deleteAll: string;
    noRecent: string;
    recentlyViewed: string;
    noResults: string;
    tryDifferentKeywords: string;
    checkSpelling: string;
    keyword: string;
  };
  login?: {
    title: string;
    invalidPhoneNumber: string;
    startLogin: string;
  };
  htmlMeta?: {
    imageAlt: string;
    description: string;
  },
  appDownloadBanner?: {
    title: string;
    subTitle: string;
    button: string;
  }
}

const translationMap: Record<string, () => Promise<any>> = {
  en: () => import("../../locales/en/en.json"),
  vi: () => import("../../locales/vi/vi.json"),
  ko: () => import("../../locales/ko/ko.json"),
};

const useTranslations = () => {
  const [translations, setTranslations] = useState<Translations>({});
  const [loading, setLoading] = useState(true);

  const loadTranslations = async (language?: string) => {
    setLoading(true);
    try {
      let currentLang = "vi";
      if (language) {
        currentLang = language;
      } else if (typeof window !== "undefined") {
        const savedLang = localStorage.getItem("selectedLanguage");
        if (savedLang) {
          currentLang = savedLang;
        }
      }
      const loadFn = translationMap[currentLang] || translationMap["vi"];
      const translationModule = await loadFn();

      await new Promise<void>((resolve) => {
        setTranslations(translationModule);
        resolve();
      });

      return translationModule;
    } catch (error) {
      console.error("Error loading translations:", error);
      setTranslations({});
      return {};
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTranslations();
  }, []);

  return { translations, loading, loadTranslations };
};

export default useTranslations;
